export default __webpack_public_path__ + "static/media/RepLi_Loader.7d60d57a.gif";